import React from 'react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';
import { fmtAmount } from './banfListUtils';

/**
 * KPI-Zeile über der BANF-Liste (Design-Handoff §2): vier Kacheln, alle Zahlen live
 * aus den Daten berechnet. "Wartet auf Ihre Freigabe" ist klickbar -> Tab Ausstehend.
 */
const Tile = ({ label, value, sub, onClick, accent, isDarkMode }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={!onClick}
    className={`relative text-left rounded-3xl border px-5 py-4 transition-all duration-200 ${
      isDarkMode
        ? `bg-gray-900/40 backdrop-blur-xl ${accent ? 'border-blue-400/40' : 'border-white/15'} ${onClick ? 'hover:bg-gray-800/50' : 'cursor-default'}`
        : `bg-white ${accent ? 'border-brand/30 shadow-[0_1px_2px_rgba(17,24,39,0.05)]' : 'border-slate-200 shadow-sm'} ${onClick ? 'hover:bg-slate-50' : 'cursor-default'}`
    }`}
  >
    <p className={`text-[10.5px] font-semibold uppercase tracking-wider ${accent ? (isDarkMode ? 'text-blue-300' : 'text-brand') : (isDarkMode ? 'text-white/50' : 'text-slate-400')}`}>
      {label}
    </p>
    <p className={`mt-1 font-mono text-2xl font-semibold ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>
      {value}
    </p>
    {sub && (
      <p className={`mt-0.5 text-xs ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`}>{sub}</p>
    )}
  </button>
);

const BanfKpiRow = ({ kpis, onGoPending, onGoSap }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">
      <Tile
        isDarkMode={isDarkMode}
        accent
        onClick={onGoPending}
        label={t('bl.kpiAwaiting')}
        value={kpis.pendingCount}
        sub={`${t('bl.kpiRequests')} · ${fmtAmount(kpis.pendingSum)}`}
      />
      <Tile
        isDarkMode={isDarkMode}
        label={t('bl.kpiLeadTime')}
        value={kpis.avgLeadDays === null ? '—' : String(kpis.avgLeadDays).replace('.', ',')}
        sub={kpis.avgLeadDays === null ? t('bl.kpiNoData') : t('bl.kpiDays')}
      />
      <Tile
        isDarkMode={isDarkMode}
        label={t('bl.kpiVolume')}
        value={fmtAmount(kpis.volumeSum).replace(' €', '')}
        sub={`EUR · ${kpis.volumeCount} BANF`}
      />
      <Tile
        isDarkMode={isDarkMode}
        onClick={onGoSap}
        label={t('bl.kpiPosted')}
        value={kpis.postedCount}
        sub={(
          <>
            {t('bl.kpiDocs')} ·{' '}
            <span className={kpis.failedCount > 0 ? (isDarkMode ? 'text-red-300 font-semibold' : 'text-red-600 font-semibold') : undefined}>
              {kpis.failedCount} {t('bl.kpiErrors')}
            </span>
          </>
        )}
      />
    </div>
  );
};

export default BanfKpiRow;
